import { atom } from 'recoil';

export const doorsWindowsArea = atom({
  key: 'doorsWindowsArea',
  default: true,
});
